/**
 * useRCA — hook pentru RCA (PRD_RCA_v1).
 */

import { useState, useEffect, useCallback } from 'react';
import { rcaService } from '../services/rcaService';

export function useRCA(organizationId) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});

  const fetch = useCallback(async () => {
    if (!organizationId) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      let list = await rcaService.getRCAsByOrganization(organizationId);
      if (filters.status) {
        list = list.filter((r) => r.status === filters.status);
      }
      if (filters.assignedToMe && filters.userId) {
        list = list.filter((r) => r.assignedTo === filters.userId);
      }
      setItems(list);
    } catch (err) {
      console.error('[useRCA] fetch failed:', err);
      setError(err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [organizationId, JSON.stringify(filters)]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    items,
    loading,
    error,
    filters,
    setFilters,
    refetch: fetch
  };
}
